var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-inline mb-0 socal"},_vm._l((_vm.icons),function(item){return _c('li',{staticClass:"list-inline-item "},[_c('a',{attrs:{"href":item.link,"target":"_blank "}},[_c('i',{class:'fab '+ item.icon})])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }